import React from "react"

class PaymentAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.completeAccountOrder = this.completeAccountOrder.bind(this);
  }
  completeAccountOrder() {
    this.props.setPaymentStatus(true);
    $.ajax({
      url: this.props.completeAccountOrderUrl,
      method: 'POST',
      dataType: 'json',
      success: data => {
        this.props.showDetailErrors(false, []);
        this.props.completeOrder({
          url: data.order_url
        });
        this.props.setPaymentStatus(false);
      },
      error: data => {
        this.props.showDetailErrors(true, data.responseText);
        this.props.setPaymentStatus(false);
      }
    });
  }
  render() {
    var showPaymentDisplayError = this.props.show_payment_display_error && (
      <div className="showPaymentDisplayError">
        {this.props.payment_display_errors.map((errorMessage, index) => (
          <p key={index}>{errorMessage}</p>
        ))}
      </div>
    );
    return (
      <div className="checkout-sub-panel payment">
        <div className="paypal-payment-summary no-top-margin">
          Your Account will be charged{' '}
          <strong>&pound;{this.props.paymentTotal}</strong> for your delivery
          items and delivery charge (if applicable).
        </div>
        {showPaymentDisplayError}
        <div className=" fl-on fl-sm-on ">
          <button
            onClick={this.completeAccountOrder}
            className="pay-on-account-button next-panel"
            disabled={this.props.show_payment_display_error}
          >
            Complete Order
          </button>
        </div>
      </div>
    );
  }
}

export default PaymentAccount;
